// Single source of truth for auth state machine values.
// Used by store/auth.js, admin-wrapper.js, app.js, login.jsx, tests.
export const AUTH_STATUS = Object.freeze({
    UNKNOWN: "unknown",
    PENDING: "pending",
    TOTP_PENDING: "totpPending",
    LOGGED_IN: "loggedIn",
    LOGGED_OUT: "loggedOut",
    EMAIL_VERIFICATION_REQUIRED: "emailVerificationRequired",
});

// Action codes returned by backend in login response `next` field.
export const AUTH_ACTION = Object.freeze({
    CHALLENGE_TOTP: "CHALLENGE_TOTP",
    SETUP_TOTP: "SETUP_TOTP",
});

// Backend error code surfaced in error.message.includes() check at build.js.
export const PAYMENT_REQUIRED = "PAYMENT_REQUIRED";
